import { openBlock as e, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ c("path", {
  "fill-rule": "evenodd",
  d: "m14.71 6.498.001 3.117c0 2.287-3.004 4.141-6.709 4.141-3.705 0-6.709-1.854-6.709-4.141a1398.635 1398.635 0 0 0-.004-3.105l.004.006v-.018c0-.589.2-1.149.558-1.656 2.44-3.448 9.334-3.364 12.032-.338.528.592.828 1.271.828 1.994Zm-2.475 1.468c.744-.538.976-1.081.976-1.468 0-.283-.113-.62-.447-.996-.963-1.08-2.872-1.785-4.974-1.757-.743.01-1.445.11-2.08.288l6.525 3.933Zm-1.607.783a8.664 8.664 0 0 1-2.626.39c-1.62 0-3.015-.408-3.956-.989-.965-.595-1.253-1.221-1.253-1.652 0-.235.076-.498.282-.79.248-.349.576-.66.971-.927l6.582 3.968Zm-2.626 1.89c2.1 0 3.974-.595 5.204-1.527l.005.503c0 .43-.288 1.056-1.253 1.652-.941.58-2.336.989-3.956.989s-3.015-.408-3.956-.99c-.965-.595-1.253-1.22-1.253-1.651a41.345 41.345 0 0 0-.003-.509c1.23.936 3.108 1.534 5.212 1.534Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  l
];
function r(d, s) {
  return e(), t("svg", o, [...n]);
}
const m = { render: r };
export {
  m as default,
  r as render
};
